module.exports = __webpack_public_path__ + "img/aeroland-tab-content-image-03.728e45bb.jpg";